@if (percentage !== undefined && !isFinished) {
  <div class="circle mr-4" [ngClass]="{success: isFinished}">
    <svg viewBox="0 0 32 32">
      <circle r="16" cx="16" cy="16" [style.stroke-dasharray]="percentage + ' 100'" />
    </svg>
    <div class="inner">
      <div class="inner">
        @if (showIcon()) {
          <mat-icon [svgIcon]="icon" [ngClass]="{success: isFinished}"></mat-icon>
        }
        @if (!showIcon()) {
          <span class="number">{{number}}</span>
        }
      </div>
    </div>
  </div>
}

@if (isFinished) {
  <img src="assets/img/troodi/check_v2.svg" alt="icon" class="success mr-4" />
}
